import React from "react";
import { Accordion } from "react-bootstrap";

interface AccordionItem {
  title: React.ReactNode;
  content: JSX.Element;
}

interface AccordionComponentProps {
  items: AccordionItem[];
  activeKey?: string | string[] | null;
  onSelect?: (key: string | null) => void;
  isROR?: boolean;
  isDashboard?: boolean;
  showArrow?: boolean;
  isUserMapping?: boolean;
}

const AccordionComponent: React.FC<AccordionComponentProps> = ({
  items,
  activeKey,
  onSelect,
  isROR = false,
  isDashboard = false,
  showArrow = true,
  isUserMapping = false,
}) => {
  return (
    <Accordion
      className={`${isDashboard ? "h-100" : ""} ${
        !showArrow ? "no-arrow" : ""
      }`}
      activeKey={activeKey}
      onSelect={(key) => onSelect?.(key as string | null)}
    >
      {items.map((item, index) => (
        <Accordion.Item
          className="mb-3"
          eventKey={index.toString()}
          key={index}
        >
          <Accordion.Header>
            <strong style={{ width: isROR ? "98%" : "100%" }}>
              {item.title}
            </strong>
          </Accordion.Header>
          <Accordion.Body
            className={isUserMapping ? "p-0" : isDashboard ? "p-2" : "p-3"}
          >
            {item.content}
          </Accordion.Body>
        </Accordion.Item>
      ))}
    </Accordion>
  );
};

export default AccordionComponent;
